import { Injectable, inject } from '@angular/core';
import { DIALOG_RETURN_TYPES, DialogService } from '@next/core-lib/dialog';
import { LocaleService } from '@next/core-lib/i18n';
import { NotificationActions } from '@next/core-lib/notification';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { filter, map, mergeMap } from 'rxjs/operators';

import * as MowingMonitorActions from './mowing-monitor.actions';
import { ImportFileDialogComponent } from '../components/import-file-dialog/import-file-dialog.component';
import { DairyAdviceService } from '../services/dairy-advice.service';

@Injectable()
export class MowingMonitorEffects {
  private readonly actions$ = inject(Actions);
  private readonly dairyAdviceService = inject(DairyAdviceService);
  private readonly localeService = inject(LocaleService);
  private readonly dialogService = inject(DialogService);

  importMonitorItems$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MowingMonitorActions.importMonitorItems),
      mergeMap(() =>
        this.dialogService.dialog(ImportFileDialogComponent, {}).pipe(
          filter(({ result, status }) => status === DIALOG_RETURN_TYPES.confirm && !!result.file),
          mergeMap(({ result }) =>
            this.dairyAdviceService.uploadMonitorItems(result.file).pipe(
              map((response) => {
                if (response.success) {
                  return NotificationActions.successSnackbar({
                    message: this.localeService.translate('upload.upload-success'),
                  });
                }

                return NotificationActions.errorSnackbar({
                  message: this.localeService.translate(response.message, response.data),
                });
              }),
            ),
          ),
        ),
      ),
    ),
  );

  importNotifications$ = createEffect(() =>
    this.actions$.pipe(
      ofType(MowingMonitorActions.importNotifications),
      mergeMap(() =>
        this.dialogService.dialog(ImportFileDialogComponent, {}).pipe(
          filter(({ result, status }) => status === DIALOG_RETURN_TYPES.confirm && !!result.file),
          mergeMap(({ result }) =>
            this.dairyAdviceService.uploadNotifications(result.file).pipe(
              map((response) => {
                if (response.success) {
                  return NotificationActions.successSnackbar({
                    message: this.localeService.translate('upload.upload-success'),
                  });
                }

                return NotificationActions.errorSnackbar({
                  message: this.localeService.translate(response.message, response.data),
                });
              }),
            ),
          ),
        ),
      ),
    ),
  );

  constructor() {}
}
